import React from "react";
import { Carousel } from "react-bootstrap";
import swn from "../assets/swnlogo.png"; 
import indra from "../assets/indra.png"; 
import plt from "../assets/plat.png"; 

import "bootstrap/dist/css/bootstrap.min.css";

const testimonials = [
  {
    name: "Swaranshree",
    headline: "Exceptional Service and Support!",
    overview: "This billing app for my jewelry business has completely transformed how we operate-delivered on time with precision by a highly professional and skilled team. Their expertise andcommitment truly set them apart.",
    logo: <img src={swn} className="img-fluid" alt="Swaranshree" style={{ maxHeight: "100px" }} />
  },
  {
    name: "Indra Construction",
    headline: "Reliable and Scalable Solutions",
    overview: "This construction management system has been a game-changer for our workflow. Delivered on time by a dedicated and professional team, it's helped us manage projects more efficientlyand stay on top of every detail.",
    logo: <img src={indra} className="img-fluid" alt="Indra" style={{ maxHeight: "100px" }} />
  },
  {
    name: "Platinum Construction",
    headline: "Wonderful Support!",
    overview: "The team delivered my project on time and exceeded expectations, thanks to theirexceptional expertise, professionalism, and dedication.",
    logo: <img src={plt} className="img-fluid" alt="plat" style={{ maxHeight: "100px" }} />
  },

];

export default function TestimonialCarousel() {
  return (
    <div className="container py-5 text-center">
      <h3 className="mb-4">What Our Esteemed Clients Say</h3>
      <Carousel indicators={true} interval={3000} >
        {testimonials.map((item, i) => (
          <Carousel.Item key={i}>
            <div className="d-flex flex-column align-items-center">
              <div className="mb-3">{item.logo}</div>
              <h5 className="mb-2">{item.headline}</h5>
              <p className="w-75 mx-auto">{item.overview}</p>
              <strong className="mt-2">— {item.name}</strong>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
